import {
  NavigationHelpers,
  ParamListBase,
  useNavigation,
} from '@react-navigation/native';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import * as Linking from 'expo-linking';

import { Line } from '../common/Line';
import { NavigateButton } from '../common/NavigateButton';
import { SettingsLayout } from '../layouts/SettingsLayout';
import { ScreensNameType } from '@navigation';
import { IS_WEB } from '@utils';

export type NavigationListViewRouteType =
  | {
      screen: ScreensNameType;
      tKey: string;
    }
  | {
      url: string;
      tKey: string;
    };

export interface INavigationListViewProps {
  title: string;
  routes: NavigationListViewRouteType[];
  breadcrumbRoutes: ScreensNameType[];
}

type NavigationPropType = NavigationHelpers<ParamListBase>;

export function NavigationListView({
  title,
  routes,
  breadcrumbRoutes,
}: INavigationListViewProps) {
  const { t } = useTranslation();
  const nav = useNavigation<NavigationPropType>();

  function navigateTo(route: NavigationListViewRouteType) {
    if ('screen' in route) {
      // FIXME: Fix types
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      nav.navigate(route.screen);
    } else {
      if (IS_WEB) {
        window.open(route.url, '_blank');
      } else {
        Linking.openURL(route.url);
      }
    }
  }

  return (
    <SettingsLayout title={title} breadcrumbRoutes={breadcrumbRoutes}>
      {routes.map((route, index) => (
        <Fragment key={index}>
          {index !== 0 && <Line />}

          <NavigateButton
            text={t(route.tKey)}
            onPress={() => navigateTo(route)}
          />
        </Fragment>
      ))}
    </SettingsLayout>
  );
}
